import { tryToJsonParse } from "src/utils";

export class Document {
    id!: number;
    name: string = '';
    private source: string = '';
    private config: {
		vs_config: {
			chunk_size: number,
			chunk_overlap: number
		},
		doc_analysis_params: {
			contract_analysis_revision: string,
			contract_analysis_classification: string[],
			contract_analysis_examples: string[],
			sentiment_analysis_threshold: number
		}
	} = {
        vs_config: {
			chunk_size: NaN,
			chunk_overlap: NaN
		},
		doc_analysis_params: {
			contract_analysis_revision: '',
			contract_analysis_classification: [],
			contract_analysis_examples: [],
			sentiment_analysis_threshold: NaN
		}
    };
    result!: string;
    created_at: string = '';
	updated_at: string = '';
    user_id!: number;
    doc_id!: number;
    agent_id!: number;
    sbx_ai_agent!: number;

    constructor(document: Partial<Document>) {
        Object.assign(this, document);
    }

    public getId() {
        return this.id;
    }

    public setName(text = '') {
        this.name = text;
    }

    public getSource() {
        return this.source;
    }

    public getConfig() {
        return this.config;
    }

    public setSource(text = '') {
        this.source = text;
    }

    public getChunkSize() {
        return this.config.vs_config.chunk_size;
    }

    public setChunkSize(num: string) {
        this.config.vs_config.chunk_size = Number(num);
    }

    public getChunkOverlap() {
        return this.config.vs_config.chunk_overlap;
    }

    public setChunkOverlap(num: string) {
        this.config.vs_config.chunk_overlap = Number(num);
    }

    public getContractRevision() {
        return this.config.doc_analysis_params.contract_analysis_revision;
    }

    public setContractRevision(text: string) {
        this.config.doc_analysis_params.contract_analysis_revision = text;
    }



    public getContractClassification(): string[] {
        if(this.config.doc_analysis_params.contract_analysis_classification) {
            return this.config.doc_analysis_params.contract_analysis_classification;
        }
        return [];
    }

    public setContractClassification(array: string[]) {
        this.config.doc_analysis_params.contract_analysis_classification = array;
    }

    public getContractExample(): string[] {
        if(this.config.doc_analysis_params.contract_analysis_examples) {
            return this.config.doc_analysis_params.contract_analysis_examples;
        }
        return [];
    }

    public setContractExample(array: string[]) {
        this.config.doc_analysis_params.contract_analysis_examples = array;
    }

    public getSentimentThreshold() {
        return this.config.doc_analysis_params.sentiment_analysis_threshold;
    }

    public setSentimentThreshold(num: string) {
        this.config.doc_analysis_params.sentiment_analysis_threshold = Number(num);
    }

    public getAgentSelect(array: {label: any; value:any}[]) {
        return array.filter(item => item.value === this.agent_id);
    }

    public setAgentId(num: number) {
        this.agent_id = num;
    }

    public setUserId(num: number) {
        this.user_id = num;
    }

    public setDocId() {
        this.doc_id = this.id;
    }

    public getResults(): DocumentResults | null {
        if(this.result) {
            return tryToJsonParse(this.result);
        }

        return null;
    }
}

export interface DocumentResults {
    llm_analysis: string;
    source?: string;
    agent?: string | number;
    sentiment_analysis: {
        text: string,
        polarity: number
    }[],
    sentiment_analysis_resume: {
        positive: number,
        negative: number,
        neutral: number
    },
    word_frequency: any,
    status: string
}